<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "FlightNotifyModal",
  props: ["activeLegNo", "headerFlightText"],

  computed: {
    ...mapState("schedule", [
      "isActiveFlightNotify",
      "FlightNoteList",
      "FlightNoteDetails",
    ]),

    parsedNotifyDetails() {
      try {
        const noteT = this.FlightNoteList.find((x) => x.ntype === "T");
        if (!noteT || !noteT.message) return [];
        const parsed = JSON.parse(noteT.message);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch (e) {
        console.error(e);
        return [];
      }
    },
  },

  methods: {
    ...mapActions("schedule", [
      "showFlightNotifyModal",
      "closeFlightNotifyModal",
      "GetFlightNotes",
    ]),

    async hideFlightNotifyModal() {
      await this.closeFlightNotifyModal();
    },

    formatDate(dateStr) {
      if (!dateStr) return "-";
      const date = new Date(dateStr);
      return date.toLocaleString("en-GB");
    },
  },

  data() {
    return {
      NotifyStatColor: ["#d3d3d3", "#10B98126", "#EF444426", "#F59E0B26"],
      NotifyStat: ["None", "Success", "Error", "Warning"],
      FlightNotifyDetails: [],
    };
  },
};
</script>

<template>
  <article id="launch-modal-Notify">
    <div class="modal is-large" :class="{ 'is-active': isActiveFlightNotify }">
      <div class="modal-background" @click="hideFlightNotifyModal"></div>
      <div
        class="modal-content animate__animated animate__zoomIn animate__faster"
        style="width: 80%; height: 70%"
      >
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <h2 class="modal-title">{{headerFlightText}} - Notification Log</h2>
            </div>
            <button class="close-btn" @click="hideFlightNotifyModal">
              <font-awesome-icon icon="times" />
            </button>
          </div>
        </div>

        <section class="modal-card-body is-large">
          <table
            class="table is-hoverable is-narrow is-striped is-bordered animate__animated animate__slideInUp is-fullwidth"
          >
            <thead>
              <tr style="position: sticky; background-color: #455f83">
                <th style="color: white">Notify Region</th>
                <th style="color: white">First Notify DT</th>
                <th style="color: white">Last Notify DT</th>
                <th style="color: white">FMESSAGE</th>
                <th style="color: white">Stat</th>
              </tr>
            </thead>

            <tbody v-if="FlightNoteDetails && FlightNoteDetails.length > 0">
              <tr
                v-for="(notifyD, index) in FlightNoteDetails"
                :key="index"
                class="bordernotifygrid"
                :style="{
                  backgroundColor: NotifyStatColor[notifyD.NotifyStat],
                }"
              >
                <td>{{ notifyD.NotifyRegion }}</td>
                <td>{{ formatDate(notifyD.FirstNotifyDT) }}</td>
                <td>{{ formatDate(notifyD.LastNotifyDT) }}</td>
                <td>{{ notifyD.NotifyText }}</td>
                <td>{{ NotifyStat[notifyD.NotifyStat] }}</td>
              </tr>
            </tbody>

            <tbody v-else>
              <tr>
                <td colspan="5" class="has-text-centered">
                  No notify data found.
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </div>
  </article>
</template>

<style scoped>
.modal-content {
  border-radius: 16px;
  width: 90%;
  max-width: 1400px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin: 5vh auto;
}

.modal-header {
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  padding: 20px 32px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 4px 0;
}

.close-btn {
  font-size: 18px;
  background: transparent;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  color: #6b7280;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: #f3f4f6;
  color: #111827;
}
</style>
